import { CASHBOX_QUERY, CASHBOX_PAGE } from '@/components/Cashbox/enum'

export function handleCashboxRedirect(url, router, routeQuery = {}) {
  const page = routeQuery.page
  if (!page?.includes(CASHBOX_QUERY.CASHBOX)) {
    return false
  }

  if (url.includes(CASHBOX_PAGE.PAYIN_STATUS_EXT)) {
    const parsedUrl = makeUrl(url)
    const uuid = parsedUrl.searchParams.get(CASHBOX_QUERY.UUID)
    router.replace({
      query: {
        ...routeQuery,
        page: CASHBOX_QUERY.CASHBOX_EXT,
        uuid,
      },
    })
  }
  else if (url.includes(CASHBOX_PAGE.PAYIN_SUCCESS)) {
    router.replace({
      query: {
        ...routeQuery,
        page: CASHBOX_QUERY.CASHBOX_SUCCESS,
      },
    })
  }
  else if (url.includes(CASHBOX_PAGE.PAYIN_ERROR)) {
    router.replace({
      query: {
        ...routeQuery,
        page: CASHBOX_QUERY.CASHBOX_ERROR,
      },
    })
  }
  else {
    return false
  }

  return true
}

function makeUrl(url) {
  try {
    return new URL(url)
  }
  catch (e) {
    return new URL(`https://beton.ua${url}`)
  }
}
